import { Component, OnDestroy, OnInit, OnChanges, ViewEncapsulation, SimpleChanges, Input, HostListener } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { ComponentCanDeactivate } from 'src/app/shared/pending-changes.guard';

import { SecurityGroups } from 'src/app/shared/securitygroups';
import { GlobalSettingsData } from 'src/app/shared/global-settings-data';
import { DocTypes } from 'src/app/shared/doc-list-entry';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service';

@Component({
  selector: 'app-edit-doc-type-item',
  templateUrl: './edit-doc-type-item.component.html',
  styleUrls: ['./edit-doc-type-item.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EditDocTypeItemComponent implements OnInit, OnDestroy, OnChanges, ComponentCanDeactivate {

  globalSettinsData: GlobalSettingsData;

  @Input() docType: DocTypes;

  docTypeCopy: DocTypes;

  docTypes: DocTypes[];

  doctype$: Observable<DocTypes[]>;

  private docTypeQuery: Subscription;
  private _documentSaveQuery: Subscription;

  listDOCKIND = [
    {
      index: 1, value: "Счета и заказы"
    },
    {
      index: 2, value: "Движение товаров"
    },
    {
      index: 3, value: "Спецификации и налоговые"
    },
    {
      index: 4, value: "Платежи"
    },
  ];

  mainCompany: number = null;

  docHeaderStatement: string = '';
  docFooterStatement: string = '';

  toolbarOptions: any = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent

    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],

    ['clean']                                         // remove formatting button
  ];

  modules: any = {
    toolbar: this.toolbarOptions
  };

  public get noChangesThere(): boolean {
    let equal: boolean = true;

    if (this.docType && this.docTypeCopy) {
      for (var props in this.docType) {
        switch (props) {
          case 'OPTIONALPARAMS':
            break;

          default:
            equal = (this.docType[props] == this.docTypeCopy[props]);
            break;
        }
        if (!equal) {
          break;
        }
      }
    }
    return equal;
  }

  constructor(
    private docApi: DocumentApiService,
    private globalsettingsservice: GetglobalsettingsService,
  ) {
  }

  // @HostListener allows us to also guard against browser refresh, close, etc.
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away

    return (this.noChangesThere);
  }

  ngOnDestroy(): void {
    console.log('*** EditDocTypeItemComponent in ngOnDestroy')

    if (this.docTypeQuery) { this.docTypeQuery.unsubscribe(); }
    if (this._documentSaveQuery) { this._documentSaveQuery.unsubscribe(); }
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** EditDocTypeItemComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** EditDocTypeItemComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** EditDocTypeItemComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {

        case 'docType':

          this.docTypeCopy = { ... this.docType };
          this.docHeaderStatement = this.docType.DOCTEXTBEFORE;
          this.docFooterStatement = this.docType.DOCTEXTAFTER;
          break;
      }
    }
  }

  ngOnInit(): void {
    console.log('*** EditDocTypeItemComponent in ngOnInit')
    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();
  }

  onTabOpen(event) { console.log('*** EditDocTypeItemComponent in onTabOpen: ' + event.index); }

  onSelectedSecurityGroup(sg: SecurityGroups) {
    console.log('*** EditDocTypeItemComponent in onSelectedSecurityGroup: ' + JSON.stringify(sg));
    this.docType.DOCSECGROUPID = sg.SECGROUPID;
  }

  onConfirm(e: number) {
    console.log('*** EditDocTypeItemComponent onConfirm: ' + e)

    switch (e) {
      default:
        console.log('*** EditDocTypeItemComponent onConfirm: (Main data) ');
        console.log('*** EditDocTypeItemComponent buttonSaveAllClick: document ' + JSON.stringify(this.docType));
        console.log('*** EditDocTypeItemComponent buttonSaveAllClick: documentCopy ' + JSON.stringify(this.docTypeCopy));

        this._documentSaveQuery =
          this.docApi.putDocTypeById(this.docType)
              .pipe(map(data => {
                this.docTypeCopy = { ... this.docType };
                this.docType = { ... this.docType };        // Trigger the changes in child components
                console.log('*** EditDocumentComponent onConfirm: *** PUT *** ');
              }))
            .subscribe();
        break;
    }
  }
}

